<template>
<!--  <div>fdfd333</div>-->
  <el-container>
    <el-header class="flex" height="50px">
      <div class="bg-brand-1 main-logo hand width-transition" :style="{'width':sideWidth}" @click="$router.push({path:'/'})">logo</div>
      <div style="flex:1;width:0;flex-direction: column;" class="flex">
        <m-user-nav-main @sideToggle="sideToggle"></m-user-nav-main>
      </div>
    </el-header>
    <el-container>
      <el-aside :width="sideWidth" class="width-transition">
        <m-side-menu :side-collapse="activeCollapse" @addTab="addTab"></m-side-menu>
      </el-aside>
      <el-main class="bg-info-light">
        <el-tabs v-model="editableTabsValue" type="card" class="bg-light padding" ref="tabs" style="height:100%;">
          <el-tab-pane
              :key="item.name"
              v-for="(item, index) in editableTabs"
              :label="item.title"
              :name="item.name"
          >
            <iframe :src="item.content" style="padding:0;margin:0;border:none 0;width:100%;height:100%;"/>
<!--            <router-view></router-view>-->
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  export default {
    name: "MainLayout",
    data(){
      return{
        breadText:[],
        activeCollapse:false,
        editableTabsValue: '',
        editableTabs: [],
      }
    },
    methods:{
      bread(){
        this.breadText = [];
        for(let i = 0;i<this.$route.meta.length;i++) {
          this.breadText.push(this.$route.meta[i]);
        }
      },
      sideToggle(toggle){
        this.activeCollapse = toggle;
      },
      addTab(item){
        let _has = false;
        for(let i=0;i<this.editableTabs.length;i++){
          if(this.editableTabs[i].name === item.id.toString()){
            _has = true;
            break;
          }
        }
        if(!_has) {
          let _path = process.env.BASE_URL.replaceAll('/','');
          this.editableTabs.push({title: item.title, name: item.id.toString(),content:'/'+_path+ item.path});
        }
        this.editableTabsValue = item.id.toString();
        // this.$router.push({path:item.path});
      },
    },
    computed:{
      sideWidth(){
        return this.activeCollapse ? '64px' : '200px';
      },
      sideClass(){
        return this.activeCollapse ? 'aaa' : '';
      }
    },
    mounted(){
      this.breadText = [];
      for(let i = 0;i<this.$route.meta.length;i++) {
        this.breadText.push(this.$route.meta[i]);
      }
    }
  }
</script>
